import { LandscapeOverlay } from '@leprecoins/landscape-overlay';
import { useUnit } from 'effector-react';
import { PropsWithChildren } from 'react';
import { agent, createComposableProvider, orientation } from 'shared/lib';
import '@leprecoins/landscape-overlay/style.css';

export const LandscapeOverlayProvider = ({ children }: PropsWithChildren) => {
	const [landscape, mobile] = useUnit([orientation.$landscape, agent.$mobile]);

	return (
		<>
			{children}
			<LandscapeOverlay opened={landscape && mobile} />
		</>
	);
};

export const withLandscapeOverlay = createComposableProvider(LandscapeOverlayProvider);
